// Lib
import React, { useMemo } from 'react';
import { Typography, Box } from '@mui/material';

// Components
import OrderInfo from './OrderInfo';
import Button from '../../Button';
import ProductsList from '../ProductsList';
import Feather from '../../Feather';
import ApproveResponse from './ApproveResponse';
import Spinner from '../../Spinner';
import TitleContainer from '../TitleContainer';
import ApprovalInfo from '../ApprovalInfo';

// Hooks
import useUser from '../../../hooks/useUser';
import useApprovals from '../../../pages/Approvals/hooks/useApprovals';
import useQtyApprovalInfo from '../../../pages/Approvals/hooks/useQtyApprovalInfo';

import ErrorMessage from '../../Error/ErrorMessage';

import { useStyles } from './OrderQtyStyles';

const OrderQty = () => {
  const { isKiteUser, email } = useUser();
  const {
    approvals,
    fullName,
    onApproveAll,
    isResponseRequired,
    isSubmitDisabled,
    onChangeResponse,
    onSubmit,
    isSaving,
    allProductsAlreadyApproved,
    comment,
    hasAllApproves,
    apiError,
  } = useApprovals();

  const { classes } = useStyles({
    isKiteUser,
    hasAllApproves,
  });

  const { order, approvals: approvalsData } = approvals;

  const { status, approvals: qtyApprovals } = useQtyApprovalInfo(
    approvalsData?.products_limits || {},
    email,
  );

  const addressesCount = useMemo(
    () => order?.addresses.length,
    [order?.addresses],
  );

  return (
    <>
      <TitleContainer
        isApproved={allProductsAlreadyApproved}
        fullName={fullName}
      />

      <OrderInfo
        isApproved={allProductsAlreadyApproved}
        addressesCount={addressesCount}
        order={order}
      />

      <Box className={classes.titleContainer}>
        <Typography className={classes.h2} variant="h2">
          Products
        </Typography>
        {!allProductsAlreadyApproved && (
          <Button
            className={classes.approveAllButton}
            variant="text"
            onClick={onApproveAll}>
            Approve All <Feather printType="stroke" type="arrowRight" />
          </Button>
        )}
      </Box>
      <ProductsList addressesCount={addressesCount} approvals={approvals} />

      <ApproveResponse
        isApproved={allProductsAlreadyApproved}
        isRequired={isResponseRequired}
        onChangeResponse={onChangeResponse}
        response={comment || approvals.approveResponse}
      />

      {apiError && <ErrorMessage message={apiError} />}
      {!allProductsAlreadyApproved && (
        <Button
          loading={isSaving}
          loadingIndicator={<Spinner size={20} height={24} />}
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          className={classes.submitButton}>
          Submit
        </Button>
      )}
      {allProductsAlreadyApproved && (
        <ApprovalInfo approvals={qtyApprovals} title={`${status} by`} />
      )}
    </>
  );
};

export default OrderQty;
